import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { InputBase, makeStyles } from '@material-ui/core'
import { SearchIcon } from '../../../eid-icons'
import { useDebounce } from '../../../core'

const useStyles = makeStyles(() => {
    return {
        searchGeneric: (props) => ({
            width: '100%',
            height: 36,
            display: 'flex',
            alignItems: 'center',
            padding: 0,
            borderRadius: 3,
            margin: 'auto',
            border: `1px solid ${props.borderColor}`,
            backgroundColor: props.bgColor,
        }),
        searchIcon: {
            width: 13,
            height: 13,
            marginLeft: 17,
        },
        input: (props) => ({
            marginLeft: 13,
            fontSize: 13,
            flex: 1,
            color: `${props.color} !important`,
            '&:focus': {
                color: `${props.hoverColor} !important`,
            },
        }),
    }
})

function Search({ handleSearch, styleData, placeholder, value }) {
    const classes = useStyles(styleData)
    const [searchKey, setSearchKey] = useState(value)

    useEffect(() => {
        if (value !== searchKey) {
            setSearchKey(value)
        }
    }, [value])

    const handleChange = (event) => {
        const keyword = event.target.value
        setSearchKey(keyword)
    }

    const debouncedValue = useDebounce(searchKey)
    useEffect(() => {
        handleSearch(debouncedValue)
    }, [debouncedValue])

    return (
        <div className={classes.searchGeneric}>
            <div className={classes.searchIcon}>
                <SearchIcon color={styleData.iconColor} />
            </div>
            <InputBase
                fullWidth={true}
                value={searchKey}
                onChange={handleChange}
                classes={{ input: classes.input }}
                placeholder={placeholder ?? 'Search'}
            />
        </div>
    )
}

Search.propTypes = {
    handleSearch: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
}

Search.defaultProps = {
    handleSearch: () => {},
    value: '',
}

export default Search
